<template>
  <div class="Guide subWrapper">
    <!-- logo + menu -->
    <LogoMenu :loadmounted="ismobile" :active-name="menuName" />
    <!-- 链接 -->
    <ul class="tabNav">
      <li v-for="(item,index) in navList" :key="index" :class="activeName == item ? 'on': ''">
        <a href="javascript:;" @click="SwitchTabFn(index)">{{ item }}</a>
      </li>
    </ul>
    <!-- 大会指南 -->
    <div class="sub_contBox" v-if="!ismobile">
      <div class="contbox_scroll">
        <div class="contbox_top">
          <!-- 大会指南 txt -->
          <div class="sub_title"><img src="../assets/image/right_arrow.png" /><span>{{ name }}</span><img src="../assets/image/left_arrow.png" /></div>
          <!-- 内容 -->
          <div class="NewsCenter_cont sub_cont">
            <div class="guideBook_tit" v-if="activeName !='当地天气'">{{ activeName }}</div>
            <div class="map_box" v-show="activeName == navList[0]"><a href="https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E9%A6%99%E6%A0%BC%E9%87%8C%E6%8B%89%E5%A4%A7%E9%85%92%E5%BA%97/@13526091.158906348,3641765.42762,19z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E9%A6%99%E6%A0%BC%E9%87%8C%E6%8B%89%E5%A4%A7%E9%85%92%E5%BA%97&c=289&src=0&pn=0&sug=0&l=19&b=(13525632.733993286,3641559.0811165324;13526554.135118334,3641972.2254919573)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1"
                target="_blank"><img src="../assets/image/map_pic.png" alt="地图" target="_blank" /></a><br /><span>(点击查看详细地图)</span></div>
            <div class="content_txt" v-if="activeName =='当地天气'">
              <iframe allowtransparency="true" frameborder="0" width="100%" height="428" scrolling="no" src="//tianqi.eastday.com/plugin/widget_v1.html?sc=1&z=1&t=0&v=1&d=5&bd=0&k=&f=&q=1&a=0&c=58362&w=140&h=428&align=center"></iframe>
            </div>
            <div class="content_txt hcsyt-wrap" v-else-if="activeName == '会场示意图'">
              <img v-for="(item,ind) in hcsytImg" :key="ind" :src="item" />
            </div>
            <div class="content_txt" v-else v-html="content"></div>
          </div>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <!-- 侧边栏 -->
        <ul class="sidebar">
          <li v-for="(item,index) in navList" :key="index" :class="activeName == item ? 'on' : ''" @click="SwitchTabFn(index)">{{ item }}</li>
        </ul>
        <!-- 内容 -->
        <div class="content_txt">
          <!-- 交通与会场 -->
          <div class="jthc_box">
            <div class="guideBook_tit" v-if="activeName !='当地天气'">{{ activeName }}</div>
            <div class="map_box" v-show="activeName == navList[0]"><a href="https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E9%A6%99%E6%A0%BC%E9%87%8C%E6%8B%89%E5%A4%A7%E9%85%92%E5%BA%97/@13526091.158906348,3641765.42762,19z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E6%B5%A6%E4%B8%9C%E9%A6%99%E6%A0%BC%E9%87%8C%E6%8B%89%E5%A4%A7%E9%85%92%E5%BA%97&c=289&src=0&pn=0&sug=0&l=19&b=(13525632.733993286,3641559.0811165324;13526554.135118334,3641972.2254919573)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1"
                target="_blank"><img src="../assets/image/map_pic.png" alt="地图" target="_blank" /></a><br /><span>(点击查看详细地图)</span></div>
            <div class="weather-wrap" v-if="activeName =='当地天气'">
              <iframe allowtransparency="true" frameborder="0" width="875" height="98" scrolling="no" src="//tianqi.eastday.com/plugin/widget_v1.html?sc=1&amp;z=1&amp;t=1&amp;v=0&amp;d=5&amp;bd=0&amp;k=&amp;f=&amp;q=1&amp;a=0&amp;c=58362&amp;w=875&amp;h=98&amp;align=center"
                class="pc_weather"></iframe>
            </div>
            <div class="hcsyt-wrap" v-else-if="activeName == '会场示意图'">
              <img v-for="(item,ind) in hcsytImg" :key="ind" :src="item" />
            </div>
            <div v-else v-html="content"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ismobile" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import {
    GuideApi,AccessRecordsApi
  } from '../request/api.js'
  import Foot from '../components/Footer.vue'
  export default {
    name: "Guide",
    data() {
      return {
        name: '大会指南',
        ismobile: false,
        navList: [],
        activeName: '',
        menuName: '',
        guestData: [],
        content: '',
        hcsytImg: ['static/img/hcsyt_1.png','static/img/hcsyt_2.png','static/img/hcsyt_3.png','static/img/hcsyt_4.png']
      }
    },
    created() {
      let wid = window.innerWidth;
      this.menuName = this.$route.query.name;
      if (wid >= 320 && wid <= 1024) {
        this.ismobile = false;
      } else {
        this.ismobile = true;
      }
    },
    mounted() {
      this.GetGuideApiFn();
      this.AccessRecordsFn();
    },
    methods: {
      // 访问记录
      AccessRecordsFn() {
        AccessRecordsApi({
          seminarTopicId: 8
        });
      },
      GetGuideApiFn() {
        GuideApi().then(res => {
          this.guestData = res.seminarSubTopics[0];
          this.activeName = this.$route.query.subName ? this.$route.query.subName : this.guestData.seminarNewsList[0].name;
          for (let i = 0; i < this.guestData.seminarNewsList.length; i++) {
            this.navList.push(this.guestData.seminarNewsList[i].name);
            if (this.activeName == this.guestData.seminarNewsList[i].name && this.activeName != '会场示意图') {
              this.content = this.guestData.seminarNewsList[i].content;
            }
          }
        });
      },
      // tab切换
      SwitchTabFn(i) {
        this.activeName = this.navList[i];
        if(this.activeName == '会场示意图') return;
        this.content = this.guestData.seminarNewsList[i].content;
      }
    },
    components: {
      LogoMenu,
      Foot
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .tabNav {
      display: none;
    }

    .content_txt {
      line-height: 30px;
      margin-top: 15px;
      font-size: 16px;
      text-align: justify;
    }

    .weather-wrap {
      display: flex;
      justify-content: center;
      padding: 40px 0;
    }

    .guideBook_tit {
      text-align: center;
      font-size: 26px;
      line-height: 60px;
      position: relative;
      margin: 20px 0;
    }

    .guideBook_tit:after {
      height: 4px;
      background-color: #1777be;
      position: absolute;
      right: 0;
      bottom: 0;
      left: 50%;
      width: 50px;
      transform: translateX(-50%);
      content: '';
    }

    .map_box {
      text-align: center;
    }

    .map_box img {
      max-width: 100%;
    }

    .hcsyt-wrap img{
      width: 100%;
      height: auto;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .tabNav {
      display: flex;
      /* border-bottom: 1px solid #ccc; */
      background-color: rgb(0, 0, 0, .3);
    }

    .tabNav li {
      width: 100%;
      /* border-left: 1px solid #ccc; */
    }

    .tabNav a {
      display: block;
      text-align: center;
      color: #FFFFFF;
      font-size: .28rem;
      line-height: .8rem;
    }

    .tabNav .on a {
      color: #2468F2;
    }

    .Guide_cont>img {
      width: 100%;
      height: auto;
      max-height: 3rem;
      margin-bottom: .4rem;
    }

    .Guide .Guide_cont {
      margin-bottom: .2rem;
    }

    .content_txt {
      font-size: .28rem !important;
      line-height: .48rem;
      text-align: justify;
    }

    .map_box {
      text-align: center;
    }

    .map_box img {
      width: 100%;
    }

    .guideBook_tit {
      text-align: center;
      font-size: .3rem;
      height: .6rem;
      position: relative;
      margin: .2rem 0;
      font-weight: bold;
    }

    .guideBook_tit:after {
      height: 4px;
      background-color: #1777be;
      position: absolute;
      right: 0;
      bottom: 0;
      left: 50%;
      width: 16%;
      margin-left: -8%;
      content: '';
    }

    /* 会场示意图 */
    .hcsyt-wrap img{
      width: 100%;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Guide.vue